import request from '../request';

export function fetch(params, options) {
  return [request, 'post', 'snapshots', params, options];
}
